<script setup lang="ts">
import { defineProps } from 'vue'
import { useI18n } from 'vue-i18n'
import { getProfessionStatus } from '@/helpers'

const { recommendedLawyersList } = defineProps({
  recommendedLawyersList: {
    type: Array,
    required: true,
    default: () => []
  }
})

const { t } = useI18n()
const currentYear = new Date().getFullYear()
const localePath = useLocalePath()

const recommendedEntities = recommendedLawyersList.map(lawyer => {
  return {
    picture: lawyer.photo,
    title: `${lawyer.name} ${lawyer.lastname}`,
    url: localePath({ name: 'lawyer-slug', params: { slug: lawyer.slug } }),
    experience: getLawyerExperience(lawyer.qualification_years),
    reviewsRating: lawyer.active_reviews_rating,
    about: lawyer.bio,
    lawyer_profession_status: lawyer.lawyer_profession_status
  }
})

function getLawyerExperience (qualificationYears) {
  const experience = currentYear - qualificationYears
  return experience + t('year_abbreviation')
}
</script>
<template>
  <div>
    <RecommendedEntities :recommended-entities-list="recommendedEntities">
      <template #badge="{status}">{{ $t(getProfessionStatus(status)) }}</template>
      <template #picture><img src="/images/lawyer.svg" alt="Lawyer" class="default-img"></template>
    </RecommendedEntities>
  </div>
</template> 